import { render, staticRenderFns } from "./EventHandlerCreate.vue?vue&type=template&id=8527234a&"
import script from "./EventHandlerCreate.vue?vue&type=script&lang=js&"
export * from "./EventHandlerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports